import apiClient from "./axios"

export const getAccountLoans = async (params = {}) => {
  const { data } = await apiClient.get("/account-loans", { params })
  return data
}

export const getAccountLoan = async id => {
  const { data } = await apiClient.get(`/account-loans/${id}`)
  return data
}

export const createAccountLoan = async payload => {
  const { data } = await apiClient.post("/account-loans", payload)
  return data
}

export const updateAccountLoan = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/account-loans/${id}`, payload)
  return data
}

export const deleteAccountLoan = async id => {
  const { data } = await apiClient.delete(`/account-loans/${id}`)
  return data
}

export const getAccountLoanBalance = async id => {
  const { data } = await apiClient.get(`/account-loans/${id}/balance`)
  return data
}

export const getAccountLoanSummary = async (borrowerType, borrowerId) => {
  const { data } = await apiClient.get("/account-loans/summary", {
    params: { borrower_type: borrowerType, borrower_id: borrowerId },
  })
  return data
}
